import type { AchievementType } from "@memorang/types";

const fetchAchievements = async (_userId: string) => {
	return {
		getAchievementList: {
			title: "",
			description: "",
			points: 0,
			level: 0,
			events: 0,
			totalEvents: 0,
			usersEarned: 0,
			icon: {
				url: "",
				backgroundColor: "",
			},
		} satisfies AchievementType,
	};
};

export default fetchAchievements;
